import React from 'react';
import styles from'./LoadingScreen.module.css';

const LoadingScreen = ({ title = "Cargando", message = "Espere un momento" }) => {

return (
  <div className={styles["loading-screen"]}>
    <div className={styles["slant-wrapper"]}>
      <div className={styles["slant-box"] + ' ' + styles["top"]} />
      <div className={styles["slant-box"] + ' ' + styles["bottom"]} />
    </div>
    <h2 className={styles["loading-title"]}>{title}</h2>
    <p className={styles["loading-message"]}>
      {message}
      <span className={styles["ellipsis"]}></span>
    </p>
  </div>
);
};

export default LoadingScreen;